import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {AthleteGameLineupsRequestParams} from "../../../domain/athlete-game-lineups/athlete-game-lineups.request-params";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {AthleteGameLineupsDomainService} from "../../../domain/athlete-game-lineups/services/athlete-game-lineups.domain-service";
import {ACTION_TYPES} from "../../../core/consts";

export class CompetitorPlayersStatsModuleAthleteLineupFetchHandler extends FetchHandler {
  controller: CompetitorPlayersStatsModuleController;
  state: CompetitorPlayersStatsModuleState;
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.athleteLineupFetch;

  static injectables = [AthleteGameLineupsDomainService];

  get requestParams() {
    let athleteId: Number = this.controller.props.fetchFullLineup ? -1 : this.controller.props?.selectedAthleteId;
    let gameId: Number = this.controller.props?.gameId;

    if(this.state?.matchWeekAthleteId > 0 && this.state?.matchWeekGameId > 0) {
      athleteId = this.state.matchWeekAthleteId;
      gameId = this.state.matchWeekGameId;
    }

    const matchWeekKey: String = this.controller.props?.matchWeekKey;
    const requestParams: AthleteGameLineupsRequestParams = new AthleteGameLineupsRequestParams(athleteId, gameId, matchWeekKey);

    return requestParams;
  }

  async action() {
    const dataSource = await this.fetch();

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});
  }
}
